import React, { FC, memo } from 'react';
import styled from 'styled-components';

import { primaryMain } from '@crehana/ui/dist/styles/colors';
import RadioButton from '@crehana/ui/dist/Radio';
import { Checkbox } from '@crehana/ui';

interface SubItemProps {
  disabled?: boolean;
}

const SubItem = styled.div<SubItemProps>`
  padding: 4px 16px;
  margin: ${({ theme }) => theme.spacing[8]} ${({ theme }) => theme.spacing[0]};
  display: flex;
  transition: color 0.2s ease-in-out;

  ${({ theme }) => theme.breakpoints.down('sm')} {
    padding: 4px 8px;
  }

  &:last-child {
    margin-bottom: 0;
  }

  ${({ disabled, theme }) => {
    if (disabled) {
      return `
        opacity: ${theme.opacity[32]};
        cursor: not-allowed !important;
      `;
    }

    return `
      @media (min-width: 1025px) {
        &:hover {
          background-color: rgba(0, 153, 255, 0.1);
          & > span { color: ${primaryMain} !important; }
        }
      }
    `;
  }}
`;

interface FilterItemProps {
  name: string;
  onClick: React.MouseEventHandler;
  isSelected?: boolean;
  disabled?: boolean;
  multipleSelection?: boolean;
  tabIndex?: number;
}

const FilterItem: FC<FilterItemProps> = ({
  multipleSelection,
  isSelected,
  disabled,
  tabIndex,
  onClick,
  name,
}) => {
  const label = name;

  return (
    <SubItem
      onClick={!disabled ? onClick : undefined}
      disabled={disabled}
      tabIndex={tabIndex}
      className="-mx-24 sm:mx-0"
    >
      {multipleSelection ? (
        <Checkbox
          checked={isSelected}
          name={name}
          label={label}
          disabled={disabled}
          wrapperProps={{
            'aria-checked': isSelected,
            'aria-disabled': disabled,
            'aria-label': name,
          }}
        />
      ) : (
        <RadioButton
          checked={isSelected}
          name={name}
          label={label}
          disabled={disabled}
          wrapperProps={{
            'aria-checked': isSelected,
            'aria-disabled': disabled,
            'aria-label': name,
          }}
        />
      )}
    </SubItem>
  );
};

export default memo(
  FilterItem,
  (prev, next) =>
    prev.isSelected === next.isSelected && prev.disabled === next.disabled,
);
